const ActionButton = ({onClick, icon, className = '', label}) => {
  const Icon = icon

  return (
    <button type="button" className={`action-button ${className}`}
      aria-label={label}
      onClick={onClick}>
      <Icon size={20} strokeWidth={1.75}/>
    </button>
  );
};

export default ActionButton;
